export default __webpack_public_path__ + "static/media/contact-popup.68ca6c94.webp";